import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import s from "../clinic.module.css";
import { Button, Field, Input, Select, useToast } from "../../ui";

export default function AdminDoctorLimits({
  doctorId,
  edit,
  setEdit,
  onSave,
}) {
  const toast = useToast();
  const [doctors, setDoctors] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    clinicAPI.getDoctors({ include_summary: "false" }).then((r) => {
      setDoctors((r.doctors || []).filter((d) => d.id !== doctorId));
    });
  }, [doctorId]);

  const save = async () => {
    setSaving(true);
    try {
      await onSave();
      toast.success("Правила сохранены");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={s.limitsLayoutSimple}>
      <div className={s.docTabIntro}>
        <p>
          Эти настройки влияют на <strong>расчёт свободных слотов</strong> на
          личном кабинете, а не на уже созданные записи. Отпуск и выходные —
          во вкладке «Расписание».
        </p>
      </div>

      <div className={s.docSection}>
        <h4 className={s.docSectionTitle}>Лимиты на день</h4>
        <p className={s.docSectionHint}>
          Если дневной лимит достигнут, новые слоты на эту дату не
          показываются.
        </p>
        <div className={s.limitsFields}>
          <Field
            label="Максимум записей в день"
            hint="Оставьте пустым, если ограничения нет"
          >
            <Input
              type="number"
              min={1}
              placeholder="Без лимита"
              value={edit.max_appointments_per_day}
              onChange={(e) =>
                setEdit({ ...edit, max_appointments_per_day: e.target.value })
              }
            />
          </Field>
          <Field
            label="Перерыв между занятиями, мин"
            hint="Между концом одного занятия и началом следующего слота"
          >
            <Input
              type="number"
              min={0}
              placeholder="0"
              value={edit.min_break_minutes}
              onChange={(e) =>
                setEdit({ ...edit, min_break_minutes: e.target.value })
              }
            />
          </Field>
        </div>
      </div>

      <div className={s.docSection}>
        <h4 className={s.docSectionTitle}>Прочее</h4>
        <div className={s.limitsFields}>
          <Field label="Замещающий тренер">
            <Select
              value={edit.substitute_doctor_id}
              onChange={(e) =>
                setEdit({ ...edit, substitute_doctor_id: e.target.value })
              }
            >
              <option value="">Не назначен</option>
              {doctors.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.full_name}
                </option>
              ))}
            </Select>
            <span className={s.fieldExplain}>
              Если тренер в отпуске, на портале предложат записаться к
              замещающему.
            </span>
          </Field>
        </div>
        <label className={s.limitsToggle}>
          <input
            type="checkbox"
            checked={edit.notify_appointments}
            onChange={(e) =>
              setEdit({ ...edit, notify_appointments: e.target.checked })
            }
          />
          <span>Напоминание тренеру о записях на завтра (email)</span>
        </label>
        {edit.notify_appointments && (
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={async () => {
              try {
                const r = await clinicAPI.notifyDoctorTomorrow(doctorId);
                toast.success(r.message || "Готово");
              } catch (e) {
                toast.error(e.response?.data?.error || "Ошибка");
              }
            }}
          >
            Отправить напоминание на завтра
          </Button>
        )}
        <Field label="Код в МИС / 1С">
          <Input
            placeholder="Для интеграции"
            value={edit.mis_external_id}
            onChange={(e) =>
              setEdit({ ...edit, mis_external_id: e.target.value })
            }
          />
        </Field>
      </div>

      <Button type="button" onClick={save} disabled={saving}>
        {saving ? "Сохранение…" : "Сохранить правила"}
      </Button>
    </div>
  );
}
